// Erklärsätze je Kategorie und Sternzahl (Feedback 04.09., 26:46 / 31:54):
// kurz, konkret, halten dem Bewerter den Spiegel vor — "Ist es wirklich nur 1 Stern?".
// Bewusst kein Tooltip, sondern ein schmaler Satz direkt unter den Sternen (auch mobil).
const HINTS = {
  communication: {
    1: 'Anfragen bleiben grundsätzlich unbeantwortet.',
    2: 'Antworten kommen selten und meist erst nach Nachhaken.',
    3: 'Man bekommt Antworten, aber nicht immer klar oder vollständig.',
    4: 'Freundlich und verständlich, kleine Lücken kommen vor.',
    5: 'Klar, freundlich und proaktiv — man fühlt sich informiert.',
  },
  service: {
    1: 'Anliegen werden nicht bearbeitet, man ist auf sich gestellt.',
    2: 'Vieles bleibt liegen oder wird nur halb erledigt.',
    3: 'Standardanliegen werden erledigt, Besonderes dauert.',
    4: 'Zuverlässig und hilfsbereit, gelegentlich etwas Nachdruck nötig.',
    5: 'Probleme werden gelöst, bevor man zweimal fragen muss.',
  },
  billing: {
    1: 'Abrechnungen sind fehlerhaft oder kommen gar nicht.',
    2: 'Häufig Fehler oder deutlich verspätet.',
    3: 'Im Großen und Ganzen korrekt, Rückfragen nötig.',
    4: 'Korrekt und nachvollziehbar, kleine Verzögerungen.',
    5: 'Pünktlich, transparent, ohne Rückfragen verständlich.',
  },
  response_time: {
    1: 'Auch nach Monaten keine Reaktion.',
    2: 'Mehrere Wochen bis zur ersten Rückmeldung.',
    3: 'Rückmeldung nach ein bis zwei Wochen — das ist branchenüblich.',
    4: 'Meist innerhalb weniger Tage.',
    5: 'Innerhalb von 24–48 Stunden, auch bei Kleinigkeiten.',
  },
  competence: {
    1: 'Fachliche Fehler mit spürbaren Folgen.',
    2: 'Unsicher bei fachlichen Fragen, Aussagen widersprechen sich.',
    3: 'Solide bei Routine, bei Sonderfällen wird es dünn.',
    4: 'Fachlich sicher, Empfehlungen sind nachvollziehbar.',
    5: 'Kennt sich hervorragend aus und denkt mit.',
  },
};

export function categoryHint(key, rating) {
  return HINTS[key]?.[rating] || '';
}

export default HINTS;
